import React from 'react'

const StartScreen = () => {
  return (
	<div className='startScreen'>Borysenko Aleksandr</div>
  )
}

export default StartScreen